import { newSpecPage } from '@stencil/core/testing'
import { CobaltIconButton } from '../cobalt-icon-button'

describe('cobalt-button', () => {
  it('renders', async () => {
    const page = await newSpecPage({
      components: [CobaltIconButton],
      html: '<cobalt-icon-button></cobalt-icon-button>'
    })
    expect(page.root).toEqualHtml(`
      <cobalt-icon-button tooltip-direction="top">
        <core-icon-button size="medium" tooltip-direction="top" type="button" variant="primary"></core-icon-button>
      </cobalt-icon-button>
    `)
  })
})
